export default __webpack_public_path__ + "static/article-5-best-aussie-roadtrips-4d227f82a437942402d6b48ccdbaddb6.jpg";